import { useCallback, useEffect } from "react";

export function useClickOutside(target: Element | null, callback: (event: MouseEvent) => void) {
  const onClick = useCallback(
    (event: MouseEvent) => {
      const eventTarget = event.target as Element;
      if (target && eventTarget && !target.contains(eventTarget) && target != eventTarget) {
        callback(event);
      }
    },
    [target, callback]
  );

  useEffect(() => {
    window.addEventListener("click", onClick);
    return () => window.removeEventListener("click", onClick);
  }, [onClick]);
}
